import { useState, useEffect } from "react";
import { useInfoBanner } from "@/hooks/useInfoBanner";
import { InfoBanner } from "./InfoBanner";

const BANNER_ROTATION_INTERVAL = 5000; // 5 seconds

export const InfoBanners = () => {
  const { banners, loading } = useInfoBanner();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (banners.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
    }, BANNER_ROTATION_INTERVAL);

    return () => clearInterval(interval);
  }, [banners.length]);

  if (loading || banners.length === 0) {
    return null;
  }

  // If only one banner, just show it
  if (banners.length === 1) {
    return <InfoBanner banner={banners[0]} />;
  }

  // Multiple banners - show slider
  return (
    <div className="relative w-full overflow-hidden">
      <div 
        className="flex transition-transform duration-500 ease-in-out"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {banners.map((banner) => (
          <div key={banner.id} className="w-full flex-shrink-0">
            <InfoBanner banner={banner} />
          </div>
        ))}
      </div>
    </div>
  );
};

